import { render, staticRenderFns } from "./worldStock.vue?vue&type=template&id=32a015b6"
import script from "./worldStock.vue?vue&type=script&lang=js"
export * from "./worldStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports